import { proxy } from 'valtio';

/**
 * The last visibility setting used by the current user when managing Author
 * Labels (defaults to false).
 * This is the visibility state that should be used when creating new elements
 * that have Author Labels enabled.
 *
 * @see modules/sticky-note-author
 */
export const authorVisibilityState = proxy<{ visible: boolean }>({
  /**
   * Whether or not the author label is visible.
   */
  visible: false,
});
